import React, { useState, useCallback } from 'react';

export const Toast = ({ message, onClose }) => (
    <div className="fixed bottom-4 right-4 bg-[#4f7a64] text-white px-4 py-2 rounded shadow-lg z-50">
        <div className="flex items-center justify-between">
            <span>{message}</span>
            <button onClick={onClose} className="ml-4 font-bold">×</button>
        </div>
    </div>
);

export const useToast = (duration = 3000) => {
    const [toastMessage, setToastMessage] = useState("");
    
    const showToast = useCallback((message) => {
        setToastMessage(message);
        setTimeout(() => setToastMessage(""), duration);
    }, [duration]);

    const hideToast = useCallback(() => {
        setToastMessage("");
    }, []);
    
    return { toastMessage, showToast, hideToast };
}; 